<script setup lang="ts">
import {ColorVariantType} from '@toolify/client/src/modules/ui/enum/ColorVariantType'

const props = withDefaults(defineProps<{
  color?: ColorVariantType
  size?: number
  fillContainer?: boolean
}>(), {
  color: ColorVariantType.Primary,
  size: 20,
  fillContainer: false,
})
</script>

<template>
  <div
    class="logo-icon logo-icon-svg"
    :class="[
      `color-${props.color}`,
      {'fill-container': props.fillContainer},
    ]"
  >
    <svg
      viewBox="0 0 160 160"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="58" cy="14" r="14"/>
      <circle cx="102" cy="14" r="14"/>
      <circle cx="146" cy="58" r="14"/>
      <circle cx="14" cy="102" r="14"/>
      <circle cx="58" cy="146" r="14"/>
      <circle cx="102" cy="146" r="14"/>
      <rect
        x="0"
        y="44"
        width="116"
        height="28"
        rx="14"
      />
      <rect
        x="44"
        y="88"
        width="116"
        height="28"
        rx="14"
      />
    </svg>
  </div>
</template>

<style scoped lang="scss">
@use '@toolify/client/src/styles/variables' as variables;

.logo-icon-svg {
  --logo-size: calc(v-bind(props.size) * 1px);
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--logo-size);
  aspect-ratio: 1 / 1;
  flex-shrink: 0;

  &.color-primary {
    color: map-get(variables.$colors, primary);
  }

  &.color-error {
    color: map-get(variables.$colors, error);
  }

  &.color-neutral {
    color: map-get(variables.$colors, content-normal);
  }

  &.color-dark {
    color: map-get(variables.$colors, content-dark);
  }

  &.color-dim {
    color: map-get(variables.$colors, content-dim);
  }

  &.color-on-primary {
    color: map-get(variables.$colors, on-primary);
  }

  &.color-darkest {
    color: map-get(variables.$colors, content-darkest);
  }

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.logo-icon-svg.fill-container {
  container-type: size;
  width: 55%;
  height: auto;
  aspect-ratio: 1 / 1;
  max-height: 100%;
  --logo-size: 100cqmin;
}
</style>
